/**
 * プロンプト本文内の {{PLACEHOLDER}} 検出・プレビュー用（管理画面）
 */

/** `{{NAME}}` 形式のプレースホルダ（先頭からの出現順・重複除く） */
export function extractBracePlaceholders(text: string): string[] {
  const re = /\{\{([^}]+)\}\}/g;
  const seen = new Set<string>();
  const order: string[] = [];
  let m: RegExpExecArray | null;
  while ((m = re.exec(text)) !== null) {
    const k = m[1].trim();
    if (!k || seen.has(k)) continue;
    seen.add(k);
    order.push(k);
  }
  return order;
}

/** サンプル値で {{...}} を置換したプレビュー文字列 */
export function applyBracePreview(text: string, samples: Record<string, string>): string {
  return text.replace(/\{\{([^}]+)\}\}/g, (_, inner: string) => {
    const k = inner.trim();
    return samples[k] ?? `〈${k}〉`;
  });
}

/** コードベースで分かっているプレースホルダの説明（キーは大文字小文字そのまま） */
export const BRACE_PLACEHOLDER_HINTS: Record<
  string,
  { label: string; description: string }
> = {
  CATEGORY_SUMMARY: {
    label: 'カテゴリ一覧サマリ',
    description:
      'ItemExtractor でルーブリックのカテゴリ説明テキストに置換されます（item_extraction）。',
  },
};

/** プレビュー用の既定ダミー（長すぎないように短く） */
export const DEFAULT_BRACE_SAMPLES: Record<string, string> = {
  CATEGORY_SUMMARY: [
    'SRC_C3 歯ブラシ（セルフケア）: 有無・事実 / 頻度 / 方法・具体 / 理由・背景 …',
    'SRC_C14 喫煙・受動喫煙の状態: …',
    '（実際の運用では、講座の条件表にあるカテゴリの要約が入ります。番号の意味は条件表の版で変わります）',
  ].join('\n'),
};

export function defaultSampleForPlaceholder(key: string): string {
  return DEFAULT_BRACE_SAMPLES[key] ?? `〈${key} の実行時に差し込まれる内容の例〉`;
}

export function hasSectionBracketMarkers(text: string): boolean {
  return /【[^】]+】/.test(text);
}
